/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BlogBlogCategory } from './blogBlogCategory';


export interface Blog { 
    archived?: boolean;
    blogCategory?: BlogBlogCategory;
    blogId?: number;
    content?: string;
    createdAt?: string;
    date?: string;
    description?: string;
    featured?: boolean;
    id?: string;
    image?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    locked?: boolean;
    path?: string;
    pdf?: string;
    published?: boolean;
    readOnly?: boolean;
    title?: string;
    updatedAt?: string;
    version?: number;
    youtubeEmbedCode?: string;
}
